var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5 3.75C19.5 1.67893 17.8211 0 15.75 0H9.25C7.17893 0 5.5 1.67893 5.5 3.75V20.25C5.5 22.3211 7.17893 24 9.25 24H15.75C17.8211 24 19.5 22.3211 19.5 20.25V3.75ZM9.25 1.40625H15.75L15.9105 1.41166C17.13 1.49412 18.0938 2.50952 18.0938 3.75V3.79688H6.90625V3.75L6.91166 3.58953C6.99412 2.36996 8.00952 1.40625 9.25 1.40625ZM6.90625 5.20312H18.0938V18.7969H6.90625V5.20312ZM6.90625 20.2031V20.25C6.90625 21.4905 7.86996 22.5059 9.08953 22.5883L9.25 22.5938H15.75C16.9905 22.5938 18.0059 21.63 18.0883 20.4105L18.0938 20.25V20.2031H6.90625Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileIcon);
export default __webpack_public_path__ + "static/media/MobileIcon.7bb6e9cf2be1b69cbbb22362556c55c3.svg";
export { ForwardRef as ReactComponent };